import React, { Component } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelInputBytes } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelTempo } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import UsuarioSessao from '../../../models/UsuarioSessao';
import { Usuario } from 'hay-core-react';
import Routerboard    from '../../../models/Routerboard';
import Plano          from '../../../models/Plano';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:       'main.usuariosessao.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
        validacao:    { obrigatorio: true },
        // Apenas usuários de classificação hotspot podem ter sessões registradas.
        filtro: {
            classificacao: { constraints: [{ value: 'main.usuario.classificacao.hotspot', matchMode: 'equals' }] },
        },
    },
    routerboard: {
        exibir:       'main.usuariosessao.routerboard',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'routerboard.entidade',
        template:     'routerboard.template',
    },
    plano: {
        exibir:       'main.usuariosessao.plano',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'plano.entidade',
        template:     'plano.template',
    },
    inicio:              { exibir: 'main.usuariosessao.inicio',              visivel: true, tipo: 'date', time: true },
    fim:                 { exibir: 'main.usuariosessao.fim',                 visivel: true, tipo: 'date', time: true },
    ip:                  { exibir: 'main.usuariosessao.ip',                  visivel: true },
    mac:                 { exibir: 'main.usuariosessao.mac' },
    ipconcentrador:      { exibir: 'main.usuariosessao.ipconcentrador' },
    idsessaorouterboard: { exibir: 'main.usuariosessao.idsessaorouterboard' },
    bytesin:             { exibir: 'main.usuariosessao.bytesin',  tipo: 'bytes' },
    bytesout:            { exibir: 'main.usuariosessao.bytesout', tipo: 'bytes' },
    // Segundos reportados pela Routerboard no encerramento da sessão. Oculto na grid por padrão,
    // mas disponível no configurador e exibido no formulário como duração humanizada.
    uptime:              { exibir: 'main.usuariosessao.uptime', tipo: 'numeric', template: 'uptime.template' },
    // Oculto na grid por padrão (disponível no configurador) — exibido apenas no formulário.
    homologacao:         { exibir: 'main.usuariosessao.homologacao', tipo: 'boolean', template: 'homologacao.template' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    usuario:     { entidade: Usuario,     template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    routerboard: { entidade: Routerboard, template: (rowData) => rowData.routerboard?.descricao || '' },
    plano:       { entidade: Plano,       template: (rowData) => rowData.plano?.descricao || '' },
    homologacao: { template: booleanTemplate('homologacao') },
    uptime:      { template: (rowData) => (rowData.uptime > 0 ? UtilService.formatarDuracaoCurta(rowData.uptime * 1000) : '—') },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class UsuarioSessaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.routerboard} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.plano} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={model.inicio} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={model.fim} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.ip} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.mac} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.ipconcentrador} contexto={contexto} />
                </div>
                
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputBytes model={model.bytesin} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputBytes model={model.bytesout} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTempo model={model.uptime} contexto={contexto} unidade="segundos" />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioSessaoTemplate extends Component {

    // Desconecta 1+ UsuarioSessao selecionadas: remove a sessão ativa correspondente no
    // /ip/hotspot/active da Routerboard (via UsuarioSessao.desconectar, que resolve a
    // Routerboard e chama o comando de fato). Não popula `fim`/UsuarioLog aqui — isso acontece
    // automaticamente pelo webhook on-logout assim que a RB confirma a desconexão.
    desconectarSessoes = () => {
        // fim=0 é o valor implícito de sessão ainda ativa (ver UsuarioSessao.desconectar) — sessões
        // já finalizadas ficam de fora mesmo que estivessem selecionadas junto de sessões ativas.
        const selected = (this.gridRef?.getSelected() || []).filter((s) => s.fim === 0);
        if (!selected.length) return;

        confirmDialog({
            message: <p>{UtilService.traduzir('main.usuariosessao.confirmacaoDesconectar.mensagem')} <b>[{selected.map(s => s.id).join(", ")}]</b></p>,
            className: 'w-3',
            header: UtilService.traduzir('main.usuariosessao.confirmacaoDesconectar'),
            icon: 'pi pi-exclamation-triangle p-error',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            draggable: false,
            accept: async () => {
                // ApiService.post nunca rejeita a promise — erro HTTP vira { status: false, data }.
                const resultados = await Promise.all(selected.map((s) => UsuarioSessao.desconectar(s.id)));
                const comSucesso = resultados.filter((r) => r?.status).length;
                if (comSucesso === resultados.length) {
                    UtilService.showToast({ severity: 'success', summary: UtilService.traduzir('main.usuariosessao.desconectar.sucesso'), detail: UtilService.traduzir('main.usuariosessao.desconectar.sucesso.detalhe') });
                } else {
                    resultados.filter((r) => !r?.status).forEach((r) => {
                        const detalhe = UtilService.traduzir(r?.data?.state) || r?.data?.mensagem || '';
                        UtilService.showToast({ sticky: true, severity: 'error', summary: UtilService.traduzir('main.usuariosessao.desconectar.erro'), detail: UtilService.traduzir('main.usuariosessao.desconectar.erro.detalhe') + detalhe });
                    });
                }
                await this.gridRef?.atualizar();
            },
        });
    }

    // Processo "Validar Sessões Ativas": não depende de seleção — varre TODAS as sessões em
    // aberto da publicação de uma vez (ver UsuarioSessao.validarSessoesAtivas), então fica sempre
    // habilitado, ao contrário de "Desconectar Sessão"/"Duplicar".
    validarSessoesAtivas = () => {
        confirmDialog({
            message: <p>{UtilService.traduzir('main.usuariosessao.confirmacaoValidarSessoesAtivas.mensagem')}</p>,
            className: 'w-3',
            header: UtilService.traduzir('main.usuariosessao.confirmacaoValidarSessoesAtivas'),
            icon: 'pi pi-exclamation-triangle p-error',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            draggable: false,
            accept: async () => {
                const resultado = await UsuarioSessao.validarSessoesAtivas();
                if (!resultado.status) {
                    const detalhe = UtilService.traduzir(resultado?.data?.state) || resultado?.data?.mensagem || '';
                    UtilService.showToast({ sticky: true, severity: 'error', summary: UtilService.traduzir('main.usuariosessao.validarsessoesativas.erro'), detail: detalhe });
                } else if (resultado.data.falhas.length === 0) {
                    UtilService.showToast({
                        severity: 'success',
                        summary: UtilService.traduzir('main.usuariosessao.validarsessoesativas.sucesso'),
                        detail: UtilService.traduzir('main.usuariosessao.validarsessoesativas.sucesso.detalhe')
                            .replace('%s', resultado.data.totalFinalizadas).replace('%s', resultado.data.totalVerificadas),
                    });
                } else {
                    const nomes = resultado.data.falhas.map((falha) => falha.descricao).join(', ');
                    UtilService.showToast({
                        sticky: true,
                        severity: 'warn',
                        summary: UtilService.traduzir('main.usuariosessao.validarsessoesativas.parcial'),
                        detail: UtilService.traduzir('main.usuariosessao.validarsessoesativas.parcial.detalhe') + nomes,
                    });
                }
                await this.gridRef?.atualizar();
            },
        });
    }

    processos() {
        return [{
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        }, {
            label:    'main.usuariosessao.desconectar',
            icon:     'pi pi-power-off',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = !selected.some((s) => s.fim === 0);
                return processo;
            },
            command: () => this.desconectarSessoes(),
        }, {
            label: 'main.usuariosessao.validarsessoesativas',
            icon:  'pi pi-sync',
            command: () => this.validarSessoesAtivas(),
        }];
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={UsuarioSessao}
                model={model}
                identidade="main.usuariosessao"
                permissoes={this.props.permissoes}
                icone="pi-clock"
                storageKey="dt-usuariosessoes"
                processos={this.processos()}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'inicio', sortOrder: -1 }}
                formulario={(m, ctx) => <UsuarioSessaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioSessaoTemplate;
